<template>
  <el-container>
    <el-header class="icon-header">
      <SiteName/>
      <div class="header-button">
        <el-button type="text" class="header-button-text">已有账号？</el-button>
        <el-button size="mini" plain round @click="$router.push({name: 'login'})">登录</el-button>
      </div>
    </el-header>
      <div class="box">
        <div class="content-title">重置密码</div>
       <div  class="account-form--wrapper">
         <!-- <div> -->
          <el-form
            ref="resetForm"
            hide-required-asterisk
            class="demo-ruleForm"
            label-position="left"
            :model="resetForm"
            :rules="resetFormRules">
            <template v-if="!isSuccess">
            <el-form-item prop="account">
              <el-input
              v-noSpace
              class="demo-ruleForm-input"
              v-model="resetForm.account"
              placeholder="请输入注册手机号或邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item prop="picCode">
               <div class="demo-ruleForm-box">
              <el-input
                v-model="resetForm.picCode"
                maxlength="4"

                  class="demo-ruleForm-input-code"
                placeholder="点击图片刷新">
              </el-input>
                <div class="third-item--less">
                <div class="pic-code--wrapper" @click="updateValicode">
                  <img :src="codePicUrl" />
                </div>
              </div>
               </div>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <div class="demo-ruleForm-box">
              <el-input v-model="resetForm.verificationCode" maxlength="4"  placeholder="请输入短信/邮箱验证码" v-noSpace class="demo-ruleForm-input-code"></el-input>
                 <div class="third-item--less">
                    <el-button plain :disabled="phoneMsgDisabled" @click="handleSendCode">{{phoneCode.msg}}</el-button>
                </div>
              </div>
              <!-- <div class="send-phone-code-btn half-item--right" :disabled="phoneCode.disabled" @click="handleSendCode">{{phoneCode.msg}}</div> -->
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model.trim="resetForm.password" placeholder="请输入新密码" class="demo-ruleForm-input" maxlength="45"></el-input>
              <div class="remark-tip">必须包含数字、字母及特殊符号，长度不少于8位，不能与登录账号一样</div>
            </el-form-item>
            <el-form-item prop="passwordAgain" class="form-item--tip">
              <el-input type="password" v-model.trim="resetForm.passwordAgain" placeholder="请再次输入新密码,确保和上述密码一致" @paste.native.capture.prevent class="demo-ruleForm-input" maxlength="45"/>
              <!-- <div class="remark-tip">确保和上述密码一致</div> -->
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :disabled="saveBtnDisabled" class="demo-ruleForm-btn" @click="handleClickFirstNext('resetForm')">提交</el-button>
            </el-form-item>
            </template>
            <template v-else>
               <el-form-item>密码已重置，<span style="color: red">{{countDown}}</span>&nbsp;后自动进入登录页面</el-form-item>
              <el-form-item><el-button type="primary"  class="demo-ruleForm-btn" @click="$router.push({ name: 'login' })">立即登录</el-button></el-form-item>
            </template>
          </el-form>
         </div>
         <!-- </div> -->
          </div>
  </el-container>
</template>

<script>
import loginMixin from './loginMixin.js'
import SiteName from '@/components/SiteName'
export default {
  mixins: [loginMixin],
  components: {
    SiteName
  },
  data() {
    var validatorPhoneOrEmail = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请填写注册手机号或邮箱'))
        this.formCheck.phoneEamilCheck = false
      } else {
        let phoneError = !/^1(3|4|5|7|8)\d{9}$/.test(value)
        let emailError = !/^([A-z0-9_-]+)@([A-z0-9_-]+)+(\.([A-z0-9_-]+))+$/.test(value)
        if (!phoneError || !emailError) {
          // 需要验证手机号或邮箱有没有注册
          const params = {
            emailOrPhone: this.$encrypt(value),
            flag: phoneError ? 1 : 0 // 0手机号,1邮箱
          }
          this.$service.checkRegister(params).then(data => {
            if (data.data === false) {
              callback(new Error('该手机/邮箱未注册账号'))
              this.formCheck.phoneEamilCheck = false
            } else {
              // 已经注册
              this.formCheck.phoneEamilCheck = true
              callback()
            }
          })
        } else {
          this.formCheck.phoneEamilCheck = false
          callback(new Error('请输入正确的手机号或邮箱'))
        }
      }
    }
    var validatorCode = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请填写验证码'))
        this.formCheck.codeCheck = false
      } else {
        if (value.length < 4) {
          callback(new Error('验证码输入有误'))
          this.formCheck.codeCheck = false
        } else {
          this.$service.checkCode({ code: value }).then(data => {
            if (data.isError) {
              this.formCheck.codeCheck = false
              callback(new Error('验证码输入有误'))
            } else {
              this.formCheck.codeCheck = true
              callback()
            }
          })
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入密码'))
      } else {
        if (/^(?![A-Za-z0-9]+$)(?![A-Za-z\W]+$)(?![0-9\W]+$)[a-zA-Z0-9\W]{8,}$/.test(value)) {
          if (this.resetForm.passwordAgain) {
            this.$refs.resetForm.validateField('passwordAgain')
          }
          callback()
        } else {
          callback(new Error('必须包含数字、字母及特殊符号，长度不少于8位'))
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请再次输入密码'))
        this.formCheck.passwordAgainCheck = false
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次输入密码不一致'))
        this.formCheck.passwordAgainCheck = false
      } else {
        this.formCheck.passwordAgainCheck = true
        callback()
      }
    }
    var validatorVerificationCode = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入验证码'))
      } else {
        this.$service
          .checkSmsCode({
            code: value,
            emailOrPhone: this.$encrypt(this.resetForm.account)
          })
          .then(data => {
            if (data.isError) {
              callback(new Error('请输入正确验证码'))
            } else {
              callback()
            }
          })
      }
    }
    return {
      formCheck: {
        codeCheck: false,
        phoneEamilCheck: false,
        passwordAgainCheck: false
      },
      activeName: 'first',
      resetForm: {
        account: undefined,
        picCode: undefined,
        verificationCode: undefined,
        password: undefined,
        passwordAgain: undefined
      },
      resetFormRules: {
        account: [
          { required: true, validator: validatorPhoneOrEmail, trigger: 'blur' }
        ],
        picCode: [
          { required: true, validator: validatorCode, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, validator: validatorVerificationCode, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }

        ],
        passwordAgain: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      phoneCode: {
        codeCount: 60,
        msg: '发送验证码',
        timer: null,
        disabled: true
      },
      codePicUrl: 'api/captcha.jpg',
      // 重置密码成功的标识
      isSuccess: false,
      // 倒计时
      countDown: 5
    }
  },
  computed: {
    phoneMsgDisabled() {
      let disabled = true
      if (
        this.formCheck.codeCheck &&
        this.formCheck.phoneEamilCheck
      ) {
        if (this.phoneCode.msg.indexOf('已发送') > -1) {
          disabled = true
        } else {
          disabled = false
        }
      }
      return disabled
    },
    saveBtnDisabled() {
      let disabled = true
      if (!this.phoneMsgDisabled && this.formCheck.passwordAgainCheck) {
        disabled = false
      }
      return disabled
    }
  },
  methods: {
    handleClickFirstNext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const resetForm = this.cloneDeep(this.resetForm)
          const isEmail = resetForm.account.indexOf('@') !== -1
          const data = {
            phone: !isEmail ? this.$encrypt(resetForm.account) : undefined,
            email: isEmail ? this.$encrypt(resetForm.account) : undefined,
            code: resetForm.picCode,
            smsCode: resetForm.verificationCode,
            newPassword: this.$encrypt(resetForm.password),
            comPassword: this.$encrypt(resetForm.passwordAgain)
          }
          this.$service.forgetPassword(data)
            .then(() => {
              this.isSuccess = true
              const timer = setInterval(() => {
                if (this.countDown > 0) {
                  this.countDown--
                } else {
                  clearInterval(timer)
                  this.$router.push({ name: 'login' })
                }
              }, 1000)
            })
            .catch(() => {
              this.updateValicode()
            })
        }
      })
    },
    updateValicode() {
      this.codePicUrl += '?_=' + new Date().getTime()
    },
    handleSendCode() {
      const phoneCode = this.phoneCode
      const resetForm = this.resetForm
      const code = resetForm.picCode
      this.$service.checkPicCode({ code }).then(() => {
        const isEmail = resetForm.account.indexOf('@') !== -1
        if (!isEmail) {
          this.genInteractionCodeMethods(phoneCode, () => {
            this.$service.sendCode({ phone: this.$encrypt(resetForm.account) })
          })
        } else {
          this.$message.info('暂未开通email验证')
        }
      }).catch(() => {
        this.updateValicode()
      })

      // const $ref = this.$refs.resetForm

      // $ref.validateField('account', (errorMsg) => {
      //   if (errorMsg !== '') {
      //     return
      //   }
      //   // 验证图片码后发送短信

      //   $ref.validateField('picCode', (errPicCode) => {
      //     if (errPicCode !== '') {
      //       return
      //     }

      //   })
      // })
    }
  },
  created() {
    this.updateValicode()
  }
}
</script>

<style lang="stylus" scoped>
.header-button-text
  color #fff
  font-size 14px
.half-item--right
  float right
.icon-header
  display flex
  flex-direction row
  display flex
  flex-direction row
  justify-content space-between
.pic-code--wrapper
  cursor pointer
  float right
  border 1px solid #dcdfe6
  border-radius 4px
  height 34px
  line-height 34px
  text-align center
.pic-code--wrapper img
  padding 10px 20px
  margin-top -10px
.box {
  // margin 3% 25%
}
.content-title {
  text-align: center;
  height: 33px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  line-height: 33px;
  margin: 40px 0;
}
.content-steps
  width 700px
  margin 0 auto
.account-form--wrapper
  // width: 700px;
  margin: 0 auto;
  margin-top: 40px;
.form-box-item
  display: flex
  flex-direction: row
.demo-ruleForm
  width 382px
  margin 0 auto
.demo-ruleForm-box {
  display flex
  align-items center
}
.demo-ruleForm-input,.demo-ruleForm-btn,.demo-ruleForm-select,.demo-ruleForm-picker {
  width 382px
}
>>>.el-radio-button__inner {
  width 191px
}
.demo-ruleForm-half-select,.demo-ruleForm-half-btn{
  width 186px
}
.demo-ruleForm-box .demo-ruleForm-half-select:nth-child(1),.demo-ruleForm-box .avatar-uploader-card>>>.el-upload:nth-child(1),.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(1),.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(2) {
  margin-right 10px
}
.demo-ruleForm-input-code {
  width 260px
  margin-right 10px
}
.remark-tip {
  min-width:317px;
  height:22px;
  font-size:12px;
  font-weight:400;
  color:rgba(0,0,0,0.45);
  line-height:22px;
  // padding-left 8px
}
.text-title
  color:rgba(0,0,0,0.85);
  font-size:12px;
  height 22px
  line-height 22px
.text-tip
  // padding: 0 32px 0px 34px;
  font-size: 12px;
  color: rgba(0,0,0,0.45);
  height: 16px;
  line-height: 16px;

</style>
